//ChartToggle.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import { BarChart3, TrendingUp } from 'lucide-react';

interface ChartToggleProps {
  activeChart: 'tradingview' | 'recharts';
  onToggle: (chartType: 'tradingview' | 'recharts') => void;
  className?: string;
}

export const ChartToggle: React.FC<ChartToggleProps> = ({
  activeChart,
  onToggle,
  className = '',
}) => {
  return (
    <div
      className={`flex items-center bg-slate-800/50 rounded-lg p-1 ${className}`}
    >
      <Button
        variant="ghost"
        size="sm"
        className={`flex items-center gap-2 rounded-md transition-all duration-200 text-sm ${
          activeChart === 'tradingview'
            ? 'bg-blue-600/80 text-white shadow-sm'
            : 'text-slate-400 hover:text-slate-200'
        }`}
        onClick={() => onToggle('tradingview')}
      >
        <TrendingUp className="h-4 w-4" />
        <span>TradingView</span>
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={`flex items-center gap-2 rounded-md transition-all duration-200 text-sm ${
          activeChart === 'recharts'
            ? 'bg-blue-600/80 text-white shadow-sm'
            : 'text-slate-400 hover:text-slate-200'
        }`}
        onClick={() => onToggle('recharts')}
      >
        <BarChart3 className="h-4 w-4" />
        <span>Recharts</span>
      </Button>
    </div>
  );
};

export default ChartToggle;
